import { string, object, number, boolean, array, } from 'yup';
const mappingSchema = object().shape({
    currencyCode: string().required().nonNullable(),
    stripePaymentsAccountExternalId: string().optional().nullable(),
});
export const stripeAccountSchema = object({
    stripeFeeAccountExternalId: string().nullable(),
    stripeContactId: number().nullable(),
    stripePaymentsAccountExternalId: string().nullable(),
    stripeSurchargesAccountExternalId: string().nullable(),
    surchargeEnabled: boolean().required(),
    surchargeFlatRateCents: number().required(),
    surchargePercentage: number().required(),
    paymentMappings: array().of(mappingSchema).required(),
    stripeFeeTaxExternalId: string().nullable(),
    stripeSurchargesTaxExternalId: string().nullable(),
    minPaymentPercent: number().required().min(0.1).max(100),
    ddSurchargeFlatRateCents: number().required(),
    ddSurchargePercentage: number().min(0).max(100).required(),
    applyBankDebitOnProcessing: boolean().optional(),
});
//# sourceMappingURL=stripeAccount.js.map